import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import SEO from '../components/SEO';
import { guides } from '../data/guides';

const Guides = () => (
  <div className="min-h-screen bg-white py-16">
    <SEO title="Guías para guardar y gestionar videos | Video Vault" description="Guías originales sobre enlaces, formatos, respaldos, privacidad, derechos de autor y solución de errores de video." path="/guias" />
    <div className="container mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <h1 className="mb-4 text-4xl font-bold md:text-5xl">Guías de Video Vault</h1>
      <p className="mb-12 max-w-3xl text-lg text-gray-600">Recursos prácticos para conservar contenido propio o autorizado, resolver errores y tomar mejores decisiones sobre calidad y uso responsable.</p>
      <div className="grid gap-6 md:grid-cols-2">
        {guides.map((guide) => (
          <Card key={guide.slug} className="border-2">
            <CardHeader><CardTitle><Link className="hover:underline" to={`/guias/${guide.slug}`}>{guide.title}</Link></CardTitle></CardHeader>
            <CardContent><p className="mb-4 text-gray-700">{guide.description}</p><p className="text-sm text-gray-500">{guide.readTime} · Actualizada el 10 de agosto de 2026</p></CardContent>
          </Card>
        ))}
      </div>
    </div>
  </div>
);

export default Guides;
